export function isMenuRouteActive(pathname, target, activeMenu) {
 if (activeMenu === target || pathname === target) return true;
 if (target === "/") return false;
 if (target === "/plugins/floup" && pathname.startsWith("/plugins/floup/dashboard")) return false;
 if (target === "/campaigns" && pathname.startsWith("/campaign/")) return true;
 if (target === "/flowbuilders" && pathname.startsWith("/flowbuilder/")) return true;
 return pathname.startsWith(`${target}/`);
}
export function menuSectionLabels(language = "pt") {
 const labels={pt:["Visão geral","Atendimento","Relacionamento","Marketing","Automação e IA","Canais","Administração","Ajuda"],en:["Overview","Inbox","Relationships","Marketing","Automation and AI","Channels","Administration","Help"],es:["Resumen","Atención","Relaciones","Marketing","Automatización e IA","Canales","Administración","Ayuda"]};
 return labels[String(language).slice(0,2)] || labels.pt;
}
